import * as React from 'react';
import Idioms from "./Idioms.js";
import Technologies from "./Technologies.js";
import Skill from "./Skill.js";
import BasicInformation from "./BasicInformation.js";
import Button from "@mui/material/Button";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import DialogCV from "./DialogCV.js";

//estilo del button
const styleButton = {
  backgroundColor: "#ffc107",
  color: "#1e1e28",
  "&:hover": {
    backgroundColor: "#ffb300",
  },
  marginTop: "15px",
  width: "200px",
  height: "28px",
  marginLeft: "15%",
};

function Statistics({isMobile = false}) {

  const [open, setOpen] = React.useState(false);

  const handleDownload = () => {
    setOpen(true);
  };


  return (
    <div>

      <DialogCV 
        open={open}
        setOpen={setOpen}
      />

      {/* Información basica */}
      <BasicInformation />

      {/* Idiomas */}
      <div className="divider mt-3" />
      <Idioms />

      <div className="divider mt-3" />

      {/* Principales tecnologias */}
      <Technologies />

      <div className="divider mt-3" />

      {/* Habilidades */}
      <Skill label="Conocimiento de Git" />
      <Skill label="Sistemas Operativos" />
      <Skill label="Base de datos relacionales y no relacionales" />
      <Skill label="Virtulizacion y Contenedores" />

      {!isMobile && 
        <Button
          type="submit"
          role={undefined}
          variant="contained"
          onClick={handleDownload}
          startIcon={<CloudDownloadIcon />}
          sx={styleButton}
        >
          Descarga mi cv
        </Button>
      }

      <div className="mb-2"> </div>
    </div>
  );
}

export default Statistics;
